import React, {ReactNode} from 'react';
import Header from 'components/acommon/Header';
import Footer from 'components/acommon/Footer';

type PageProps = {
  children: ReactNode;
  showHeader?: boolean;
  showFooter?: boolean;
  showFooterOnlyMobile?: boolean;
  showHeaderOnlyDesktop?: boolean;
  paddingBottomMobileFooter?: boolean;
  footerTitle?: string;
};

const defaultProps: PageProps = {
  children: '',
  showHeader: true,
  showFooter: false,
  showFooterOnlyMobile: false,
  showHeaderOnlyDesktop: false,
};

function Page({
  children,
  showHeader,
  showFooter,
  paddingBottomMobileFooter,
  showHeaderOnlyDesktop,
  showFooterOnlyMobile,
  footerTitle,
}: PageProps) {
  const isShowFooter = showFooter || showFooterOnlyMobile;
  const isShowHeader = showHeader || showHeaderOnlyDesktop;

  return (
    <>
      {isShowHeader && <Header title={footerTitle} onlyForDesktop={showHeaderOnlyDesktop} />}
      {children}
      {isShowFooter && (
        <Footer
          onlyForMobile={showFooterOnlyMobile}
          paddingBottonMobile={paddingBottomMobileFooter}
        />
      )}
    </>
  );
}

Page.defaultProps = defaultProps;

export {Page};
